<p-dialog #dialog appendTo="body" [header]="header" [(visible)]="visible" [modal]="true"
  [resizable]="false" (onHide)="hide()" [style]="{'width': '1000px', 'height': '560px'}">

  <div class="row" style="display: block; width: 100%; margin-bottom: 5px;">
    <label class="col-lg-3">Total Devices: {{totalDeviceCount}}</label>
    <span class="col-lg-1"></span>
    <label class="col-lg-3">Selected Devices: {{selectedDeviceCount}}</label>
    <span class="col-lg-1"></span>
    <span class="col-lg-4">
      <label style="margin-right: 5px;">Device Filter:</label>
      <select (change)="onSelectedFilterChange($event)">
        @for (fe of filterEntries; track fe) {
          <option value="{{fe.index}}">{{fe.name}}</option>
        }
      </select>
    </span>
  </div>

  @if (devicesLoading && entries.length == 0) {
    <div>
      Loading devices ...
    </div>
  }

  @if (!devicesLoading && entries.length == 0) {
    <div>
      No devices ...
    </div>
  }

  @if (entries.length > 0) {
    <uv-table #table class="selector-devices-table" [value]="entries" compareSelectionBy="equals"
      [resizableColumns]="true" [rows]="10" [(first)]="first"
      [scrollable]="true" scrollHeight="calc(380px)"
      [customSort]="true" (sortFunction)="doCustomSort($event)"
      [(selection)]="selectedDevices" (onFilter)="onFilterChange()"
      [virtualScroll]="true" [virtualScrollItemSize]="VirtualScrollItemSize">
      <ng-template pTemplate="header">
        <tr>
          @if (maxDevices == 1) {
            <th class="uv-table-checkbox"></th>
          }
          @if (maxDevices > 1) {
            <th class="uv-table-checkbox">
              <uv-tableHeaderCheckbox></uv-tableHeaderCheckbox>
            </th>
          }
          @for (col of cols; track col) {
            <th uvResizableColumn [uvSortableColumn]="col.field">
              {{col.header}}
              <uv-sortIcon [field]="col.field"></uv-sortIcon>
            </th>
          }
        </tr>
        <tr>
          <th class="uv-table-checkbox"></th>
          @for (col of cols; track col) {
            <th>
              <input #filter pInputText type="text" style="width: 100%;"
                (input)="table.filter($event.target.value, col.field, col.filterMatchMode)">
              </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr [style]="TableRowStyle" [uvSelectableRow]="rowData">
            @if (maxDevices == 1) {
              <td class="uv-table-checkbox">
                <uv-tableRadioButton [value]="rowData"></uv-tableRadioButton>
              </td>
            }
            @if (maxDevices > 1) {
              <td class="uv-table-checkbox">
                <uv-tableCheckbox [value]="rowData"></uv-tableCheckbox>
              </td>
            }
            @for (col of cols; track col) {
              <td>
                <span class="uv-table-value">{{rowData[col.field]}}</span>
              </td>
            }
          </tr>
        </ng-template>
      </uv-table>
    }

    <p-footer>
      <button type="button" pButton icon="fa fa-check" [disabled]="!isOkEnabled()"
      (click)="onOkClicked()" label="OK"></button>
      <button type="button" pButton icon="fa fa-times" [disabled]="false"
      (click)="onCancelClicked()" label="Cancel"></button>
    </p-footer>

  </p-dialog>